import React from 'react';
import ProjectInfoContextProvider from '../ProjectContexts/ProjectInfoContext/ProjectInfoContextProvider';
import GlobalStoreContextProvider from './Contexts/GlobalStoreContext/GlobalStoreContextProvider';
import useHandleDeviceUpdate from './Contexts/GlobalStoreContext/Hooks/dualChannelAudio/useHandleDeviceUpdate';
import useAssistant from './Contexts/GlobalStoreContext/Hooks/useAssistant';
import useCardPreload from './Hooks/useCardPreload';
import useVisibilityDisplayUpdate from './Hooks/useVisibilityDisplayUpdate';

function GlobalContextProviderInner({ children }: { children: React.ReactNode }) {
  useCardPreload();
  useAssistant();
  useVisibilityDisplayUpdate();
  useHandleDeviceUpdate();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default function GlobalContextProvider({ children }: { children: React.ReactNode }) {
  return (
    <GlobalStoreContextProvider>
      <ProjectInfoContextProvider>
        <GlobalContextProviderInner>
          {children}
        </GlobalContextProviderInner>
      </ProjectInfoContextProvider>
    </GlobalStoreContextProvider>
  );
}
